import { _Object } from './object';

export namespace Domain {
  export import Object = _Object;
}
